(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zz-footer-2"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    if (!customElements.get('footer-menu')) {
      class FooterMenu extends DetailsDisclosure {
        constructor() {
          super();
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }

        reset() {
          const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
          this.disclosure.open = isLargeScreen;

          if (isLargeScreen) {
            this.toggle.setAttribute('tabindex', '-1');
          } else {
            this.toggle.removeAttribute('tabindex');
          }
        }
      }

      customElements.define('footer-menu', FooterMenu);
    }
  });

  // Klaviyo onsite form trigger — clicking the newsletter button opens the Klaviyo form
  document.addEventListener('click', function (evt) {
    const trigger = evt.target.closest('.js-klaviyo-form-trigger');
    if (!trigger) return;
    const formId = trigger.dataset.klaviyoFormId;
    if (!formId) return;
    evt.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });

  // Chat-Support: Klick löst den hinterlegten Chat-Trigger aus
  document.addEventListener('click', function (evt) {
    const btn = evt.target.closest('.js-zz-open-chat');
    if (!btn) return;
    evt.preventDefault();
    const selector = btn.dataset.zzChatTrigger;
    if (selector) {
      const target = document.querySelector(selector);
      if (target) {
        target.click();
        return;
      }
    }
    // Fallback: bekannte Chat-Widgets direkt ansprechen
    if (window.$chatwoot && typeof window.$chatwoot.toggle === 'function') { window.$chatwoot.toggle('open'); return; }
    if (window.$zoho && window.$zoho.salesiq) { window.$zoho.salesiq.floatwindow.visible('show'); return; }
    if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') { window.Tawk_API.maximize(); return; }
    if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') { window.GorgiasChat.open(); return; }
    if (window.zE) { window.zE('messenger', 'open'); return; }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zz-footer"] && !Shopify.designMode) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    if (!customElements.get('footer-menu')) {
      class FooterMenu extends DetailsDisclosure {
        constructor() {
          super();
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }

        reset() {
          const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
          this.disclosure.open = isLargeScreen;

          if (isLargeScreen) {
            this.toggle.setAttribute('tabindex', '-1');
          } else {
            this.toggle.removeAttribute('tabindex');
          }
        }
      }

      customElements.define('footer-menu', FooterMenu);
    }
  });

  // Klaviyo onsite form trigger — clicking the newsletter button opens the Klaviyo form
  document.addEventListener('click', function (evt) {
    const trigger = evt.target.closest('.js-klaviyo-form-trigger');
    if (!trigger) return;
    const formId = trigger.dataset.klaviyoFormId;
    if (!formId) return;
    evt.preventDefault();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });

  } catch(e) { console.error(e); }
})();
})();
